module.exports = __webpack_public_path__ + "web/img/img1.eee8e1ae.png";